<template>
  <div>
    <!-- 不知道是什么东X <div v-if="isSearch">
      <Search @isClickSearch="isClickSearch"/>
    </div> -->
    <div>
      <div v-if="isError" :class="'appraisal-report' + (isAI ? ' ai' : ' zj')">
      <!-- 指定渠道 -->
        <template v-if="channelID === 6256786"> 
            <WoodReport :dataRef="dataRef"></WoodReport>
        </template>
        <!-- <div class="water-mark" v-watermark="watermarkConfig"/> -->
        <!-- 字节渠道 -->
        <!-- 9895680 ceshi字节 9776119 测试保险 | 2193521 2839586 正式 -->
        <template v-else-if="channelID === 9776119 || channelID === 9895680 || channelID === 2193521 || channelID === 2839586 || channelID === 9336941000">
            <div class="water-mark" v-watermark="watermarkConfig"/> 
            <manual-report
              :brandName="brandName"
              :kindName="kindName"
              :OAID="OAID"
              :sequence="sequence"
              :genuine="genuine"
              :suggestion="suggestion"
              :isReal="isReal"
              :bytedanceImage="bytedanceImage"
              :aIToManualResult="aIToManualResult"
              :isToManualRealTimeOrder="isToManualRealTimeOrder"
              :isManual="oldIsManual"
            ></manual-report>
        </template>
        <!-- 普通鉴定扣报告 -->
        <template v-else>
          <!-- <div class="water-mark" v-watermark="watermarkConfig"/>  -->
          <!-- 是AI 这个AI指的是非中检（包含manul） -->
          <!-- 闲鱼的在这里哦 -->
          <TuringReport v-if="isAI"
            :aIToManualResult="aIToManualResult"
            :cardRatings="cardRatings"
            :genuine="genuine"
            :isPcFlag="isPcFlag"
            :brandName="brandName"
            :kindName="kindName"
            :OAID="OAID"
            :isManual="oldIsManual"
            :sequence="sequence"
            :SARecordList="SARecordList"
            :kindID="kindID"
            :brandID="brandID"
            :seriesID="seriesID"
            :hierarchy="hierarchy"
            :isToManualRealTimeOrder="isToManualRealTimeOrder"
            :appid="appid"
            :appraisalRemark="appraisalRemark"
          />
          <!-- 是中检 -->
          <div class="bodydiv" v-if="!isAI">
            <div class="ccic-top" :style="`background-image: url(${header});`"></div>
            <div class="top-desc">
              <div class="desc_title">
                产品信息
              </div>
              <div :class="'desc_result' + (ifFake ? ' fake' : ' real')">
                {{ ifFake ? "不符合正品工艺" : "符合正品工艺" }}
              </div>
              <div class="desc_container">
                <div class="breif_info">
                  <div class="info_item">
                    <div>
                      <span class="desc_label">商品品牌:</span>
                      <p>{{ brandName }}</p>
                    </div>
                    <div>
                      <span class="desc_label">商品品类:</span>
                      <p>{{ kindName }}</p>
                    </div>
                    <div>
                      <span class="desc_label">鉴别编号:</span>
                      <p>{{ OAID }}</p>
                    </div>
                  </div>
                  <div class="info_img">
                    <img :src="exteriorUrl" />
                    <div class="img_mark"></div>
                  </div>
                </div>
                <div class="desc">
                  <span class="desc_label">整体评价:</span>
                  <div v-show="showMore" class="label_container">
                    <p>
                      {{
                        `${descList[0]}${
                          descList[1] ? descList[1].slice(0, 2) : ""
                        }...`
                      }}
                    </p>
                  </div>
                  <div v-show="!showMore" class="label_container">
                    <!-- 根据具体行数判断 -->
                    <p v-for="(item, index) in descList" :key="index">
                      {{ item }}
                    </p>
                  </div>
                </div>
                <div class="more">
                  <p v-show="showMore" @click="descShowMore(1)">查看更多</p>
                  <p v-show="!showMore" @click="descShowMore(0)">收起</p>
                </div>
              </div>
            </div>
            <div class="bottom-detail">
              <div class="detail_title">
                <h3>细节检测</h3>
              </div>
              <div class="detail_container">
                <van-tabs>
                  <van-tab
                    v-for="(item, index) in SARecordList"
                    :key="index"
                    :title="item.pointName"
                  >
                    <div class="point_content">
                      <div class="precent">
                        <div>
                          <span
                            class="position_text"
                            :style="
                              `left: ${parseInt(
                                (item.grade * 100).toFixed()
                              )}%; transform: scale(0.9) translateX(-${
                                parseInt((item.grade * 100).toFixed()) >= 50 ? 65 : 10
                              }%);`
                            "
                            >符合度{{ parseInt((item.grade * 100).toFixed()) }}%</span
                          >
                          <span
                            class="position"
                            :style="
                              `left: ${parseInt((item.grade * 100).toFixed())}%`
                            "
                          ></span>
                        </div>
                        <div class="linear"></div>
                        <div class="precent_tip">
                          <span>0% 仿品</span><span>100% 正品</span>
                        </div>
                      </div>
                      <div
                        class="ponit_pic"
                        :style="
                          ifFake && item.fakePoints.length > 0
                            ? 'justify-content: space-between;'
                            : 'justify-content: center;'
                        "
                      >
                        <div
                          :class="
                            ifFake && item.fakePoints.length > 0 ? 'picT' : 'trueP'
                          "
                        >
                          <img
                            :src="item.image"
                            :class="
                              ifFake && item.fakePoints.length > 0 ? '' : 'truePic'
                            "
                            alt=""
                          />
                          <div
                            :class="
                              ifFake && item.fakePoints.length > 0
                                ? 'pic_markF'
                                : 'pic_markT'
                            "
                          >
                            <img
                              v-if="
                                (ifFake && item.fakePoints.length > 0) ? false : true
                              "
                              class='trueArea'
                              ref="detectionBox"
                              src="https://oss.turingsenseai.com/15952947223287.png"
                              :style="
                                `left:${item.detectionBox.x *
                                  ((isPcFlag ? 300 * 1.1 : screenWidth * 0.74 * 0.5) /
                                    item.originalBox.width)}px;
                                top:${item.detectionBox.y *
                                  ((isPcFlag ? 270 : screenWidth * 0.73 * 0.6) /
                                    item.originalBox.height)}px;
                                width:${item.detectionBox.width *
                                  ((isPcFlag ? 300 * 1.1 : screenWidth * 0.73 * 0.7) /
                                    item.originalBox.width)}px;
                                height:${item.detectionBox.height *
                                  ((isPcFlag ? 300 * 1.1 : screenWidth * 0.73 * 0.6) /
                                    item.originalBox.height)}px;`
                              "
                            />

                            <img
                              v-else
                              class='trueArea'
                              ref="detectionBox"
                              src="https://oss.turingsenseai.com/15952947223287.png"
                              :style="
                                `left:${item.detectionBox.x *
                                  ((isPcFlag ? 260 * 1.1 : screenWidth * 0.73 * 0.5) /
                                    item.originalBox.width)}px;
                                top:${item.detectionBox.y *
                                  ((isPcFlag ? 230 : screenWidth * 0.73 * 0.6) /
                                    item.originalBox.height)}px;
                                width:${item.detectionBox.width *
                                  ((isPcFlag ? 260 * 1 : screenWidth * 0.73 * 0.5) /
                                    item.originalBox.width)}px;
                                height:${item.detectionBox.height *
                                  ((isPcFlag ? 260 * 1 : screenWidth * 0.65 * 0.5) /
                                    item.originalBox.height)}px;
                                object-fit: fill;`
                              "
                            />
                          </div>
                          <p>原图</p>
                        </div>
                        <div v-if="ifFake && item.fakePoints.length > 0" class="picF">
                          <img :src="item.croppedImageURL" alt="" />
                          <!-- 红点热区修改比例即可 -->
                          <div
                            :class="
                              ifFake && item.fakePoints.length
                                ? 'pic_markF'
                                : 'pic_markT'
                            "
                          ></div>
                          <p>偏假区域</p>
                        </div>
                      </div>
                      <div class="point_dsc">
                        <p>
                          {{ item.description }}
                        </p>
                      </div>
                    </div>
                  </van-tab>
                </van-tabs>
              </div>
            </div>
          </div>
          
          <div v-if="!isAI" class="ccic-bottom"></div>
        </template>

        <van-popup
          :class="clientWidth > 500 ? 'boswer_poster' : 'poster'"
          v-model="show"
          position="bottom"
          :lock-scroll="true"
          :lazy-render="false"
          closeable
          @opened="savePic"
          :style="{
            height: '70vh',
            width: clientWidth > 500 ? '575px' : '',
            overflow: 'hidden',
          }"
        >
          <!-- <div class="pc-mark" v-show="pcMark"><van-loading /></div> -->
          <div class="poster_title">
            <span>保存到相册</span>
          </div>
          <vue-canvas-poster
            :widthPixels="0"
            :painting="painting"
            @success="success"
            @fail="fail"
          ></vue-canvas-poster>
          <div
            class="poster_container"
            style="width:100%;height:100%;justify-content: center;display:flex;margin-top:20px"
          >
            <img
              v-if="posterPic"
              style="height:400px;width:250px;-webkit-touch-callout: none;"
              :src="posterPic"
              alt=""
            />
          </div>
          <van-button
            style="position: fixed;bottom:0px;"
            class="save"
            type="primary"
            size="large"
            @click="download"
            >点击或长按保存图片</van-button>
        </van-popup>

<!-- 1642243026700643525  || channelID === 9336941 -->
        <div v-if="isReal && (channelID === 9895680 || channelID === 2193521 || channelID === 2839586)" class="share" @click="show = !show">
          <span>保存海报</span>
          <div></div>
        </div>
        <div v-if="!isPcFlag" class="bottom-btn" :style="saveLoading ? '' : 'display:none;'">
          <van-loading size="60px" />
        </div>
        <div id="zp-report-qrcode" style="display:none"></div>

      </div>
    </div>
  </div>
</template>


<script>
/** !!!注意:
 * 用前必读
 * 这个报告是所以挂签相关报告，字节、保险、自定义渠道等各个渠道来源，
 * 还包括了小程序C端引流挂签报告详情
 * add 闲鱼挂签的渠道ID => 9336941
 */
import TuringReport from './ai.vue'
import ManualReport from './manual.vue'
import WoodReport from './wood.vue'
import "@/common/js/watermark.js";
import bg0 from '@/assets/images/appraisal/ccic.png'
import bg2 from '@/assets/images/appraisal/header.png'
import bg1 from '@/assets/images/appraisal/ai.png'
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { HOST_ADDRESS, isTestEnv } from "../../common/constant";
import {
  fetchAppraisalReportDetail,
  fetchAppraisalReportDetailV2
} from "@/common/api/appraisal.js";
// import Search from './components/search.vue'



const GENUINE_TYPE = {
  '0': {
    desp: '不符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1628679598180643073.png'
  },
  '1': {
    desp: '符合正品工艺',
    sealImg: 'https://oss.turingsenseai.com/1628575872053959757.png'
  },
  '2': {
    desp: '无法鉴定',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png'
  },
  '3': {
    desp: '待补图',
    sealImg: 'https://oss.turingsenseai.com/1628582036592914079.png'
  }
}

export default {
  components: {
    TuringReport,
    ManualReport,
    WoodReport,
    // Search
  },
  mounted() {
    this.getInfo();
    // webfunnyEvent(8).trackEvent({ "appid": isTestEnv ? "baoH5__test" : "baoH5", baoGuangYeMian: '挂签鉴定报告曝光',uuid: this.wfuuid })
  },
  data() {
    return {
      appid: '',
      eleLoading: false,
      saveLoading: false,
      ccic: bg0,
      ai:bg1,
      header: bg2,
      isError: false,
      // 挂签中用来判断是否是人工绑定挂签
      oldIsManual: false,
      clientWidth: "",
      imgData: "",
      // 组件
      watermarkConfig: {
        //水印
        text: "图灵鉴定",
        font: "18px 微软雅黑",
        textColor: "rgba(255,255,255,0.1)",
        width: 170, //水印文字的水平间距
        height: 60, //水印文字的高度间距（低于文字高度会被替代）
        extRotate: -30, //-90到0， 负数值，不包含-90
      },
      showMore: true,
      descList: [],

      // 获取数据
      isAI: true,     // 是ai鉴定还是中检鉴定
      ifFake: false, // 是否符合
      kindName: "",
      brandName: "",
      kindID: "",
      brandID: "",
      seriesID: "",
      hierarchy: "",
      seriesName: "",
      description: "",
      appraisalRemark: "",
      descriptionList:[],
      exteriorUrl: "", // 外观图片URL
      appraisalTime: [],
      SARecordList: [], // 详情鉴定列表
      precent: 0,
      OAID: "",
      fakePoints: [],
      exteriorUrlList: [],
      qrcode: "",
      // 弹出层
      show: false,
      backBase64: "",
      exteriorBase64: "",
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      DBwidth: "",
      // 海报图片
      posterPic: "",
      isPosterPic: true,
      isPcFlag: "",
      Flag: true,
      openError : false,
      sequence: "",  // 序列号
      // tagType: 0,  // 0是普通鉴定扣， 1是人工鉴定扣
      isReal: true,
      genuineType: {},
      genuine: '1',
      painting: {},
      dataRef: {},

      // 线上bug补救字段
      isSearch: false,
      
      // 字节渠道
      channelID: '',
      bytedanceImage: [],
      aIToManualResult: '',
      cardRatings: [],
      isToManualRealTimeOrder: null,
    };
  },
  created() {
    const { appid = '' } = this.$route.query || {}
    this.appid = appid // 备用appid 用于记录是哪个小程序
  },
  methods: {
    success(src) {
      this.posterPic = src;
    },
    fail(err) {
      console.log(err);
    },
    isClickSearch (input) {
      this.isSearch = false
      this.getData(true, input)
    },
    getInfo () {
      this.isPcFlag = this.IsPc();
      this.clientWidth = window.clientWidth;
      // // error判断 线上问题紧急方案支持修复
      // if (this.$route.params.sequence == "24054578") {
      //   this.isSearch = true
      // } else {
      // }
      this.sequence = this.$route.params.sequence
      this.getData(false)
    },
    async getData(isSearchGet, searchInput) {
      if (isSearchGet) {
        this.sequence = searchInput
      }
      await fetchAppraisalReportDetailV2({ serialNum: isSearchGet ? searchInput : this.sequence }).then((res) => {
        this.isError = true;
        if (res.errorMsg == "Success") {
          this.dataRef = res;
          // isAI 做路由兼容 保证生成二维码网址不变 防止已经生成的跳转码出问题
          // 例：原地址  https://baoh5test.turingsenseai.com/#/appraisal-report/0/TCF0HUVLE6
          //    正确跳转 https://baoh5test.turingsenseai.com/#/appraisal-report/1/TCF0HUVLE6
          // 例：修改后  https://baoh5test.turingsenseai.com/#/appraisal-report/TCF0HUVLE6
          // this.isAI = res.appraisalType === 1
          this.isAI = res.appraisalType !== undefined
                                            ? res.appraisalType !== 2  // 1-AI,2-中检
                                            : this.$route.params.ai != 1;
          this.ifFake = res.genuine == "1" ? false : true;  // 这只能判断当普通AI和中检时的真假
          this.suggestion = res.suggestion;
          this.isToManualRealTimeOrder = res.isToManualRealTimeOrder
          this.kindName = res.kindName;
          this.brandName = res.brandName;
          this.kindID = res.kindID;
          this.brandID = res.brandID;
          this.seriesID = res.seriesID;
          this.hierarchy = res.hierarchy;
          this.seriesName = res.seriesName;
          this.description = res.description;
          this.appraisalRemark = res.appraisalRemark;
          this.oldIsManual = res.isManual
          this.aIToManualResult = res.aIToManualResult
          this.descriptionList.push(res.description.slice(0,19))
          this.descriptionList.push(res.description.slice(19,39))
          let lastText = `${res.description.slice(39).split('。')[0]}，${res.description.slice(39).split('。')[1]}。`
          this.descriptionList.push(lastText)
          this.exteriorUrl = `data:image/png;base64,${res.exteriorUrl}`;
          this.OAID = res.OAID;
          this.precent = res.grade * 100; //综合评分
          res.SARecordList.forEach((item, index) => {
            if (this.oldIsManual) {
              // 人工
              this.SARecordList.push(item);
            } else {
              // ai报告首图去除
              this.SARecordList.push(item);
              // if (index !== 0) {
              // }
            }
          });
          this.appraisalTime = res.appraisalTime.split(" ")[0].split("-");
          this.descList = this.description.split("\n");

          // 下面用来判断是AI鉴定还是人工鉴定，根据后端返回是否是人工鉴定扣判断
          this.channelID = res.channelId;
          this.isReal = res.genuine == '1' || res.aIToManualResult == 1
          this.genuineType = GENUINE_TYPE[res.genuine]
          this.genuine = res.genuine;
          this.bytedanceImage = res.bytedanceImage
          if(res.cardRatings.length) {
            this.cardRatings = [...res.cardRatings].sort(function(a, b){return a.point-b.point})
          }

          // this.genuine = '1';

          // this.isReal = this.genuine == '1';
          // this.genuineType = GENUINE_TYPE[this.genuine];
          // this.bytedanceImage = [
          //   'https://oss.turingsenseai.com/1628672040888830257.png',
          //   'https://oss.turingsenseai.com/1628672040888830257.png',
          //   'https://oss.turingsenseai.com/1628672040888830257.png',
          //   'https://oss.turingsenseai.com/1628672040888830257.png',
          // ]

        } else {
          this.isError = false;
        }
      });
      await this.creatQrCode();
      this.painting = {
        width: `1254px`,
        height: `1920px`,
        background: "https://oss.turingsenseai.com/1680604823536036352.png",
        views: [
          {
            type: "text",
            text: this.brandName,
            css: {
              top: "905px",
              left: "330px",
              color: "#828393",
              fontSize: "40px",
            },
          },
          {
            type: "text",
            text: this.OAID,
            css: {
              top: "1007px",
              left: "330px",
              color: "#828393",
              fontSize: "40px",
            },
          },
          {
            type: "image",
            url: this.imgData,
            css: {
              top: "1450px",
              left: "900px",
              width: "220px",
              height: "220px",
            },
          },
        ],
      };
    },
    download() {
      let imgData = this.posterPic;
      this.downloadFile('poster.png', imgData);
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    descShowMore(flag) {
      flag ? (this.showMore = false) : (this.showMore = true);
    },
    savePic() {
      // 没啥用
      if ( this.openError ) {
        Toast.loading({
          message: '图片加载失败请刷新重试',
        });
      }

      if (this.Flag) {
        document.scrollingElement.scrollTop = 0;
        this.saveLoading = true
        let that = this
        setTimeout(() => {
          html2canvas(this.$refs.image, {
            useCORS: true,
            // scale: 4,
            // scrollY: 0,
            // scrollX: 0,
          }).then((canvas) => {
            this.posterPic = canvas.toDataURL("image/png");
            this.saveLoading = false
            this.Flag = false
            this.isPosterPic = false;
            that.posterPic = canvas.toDataURL("image/png");
            that.saveLoading = false
            that.Flag = false
            that.isPosterPic = false;
            // let imgData = canvas.toDataURL("image/png");
            // 保存方式
          });
        }, 2000);
        setTimeout(() => {
          this.saveLoading = false
        }, 2200);
      }
    },
    async creatQrCode() {
      this.qrcode = new QRCode(document.getElementById("zp-report-qrcode"), {
        // text: `${HOST_ADDRESS()}appraisal-report/${this.$route.params.ai}/${
        //   this.$route.params.sequence
        // }`, // 需要转换为二维码的内容
        text: `${HOST_ADDRESS()}appraisal-report/${
          this.$route.params.sequence
        }`, // 需要转换为二维码的内容
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: 1,
      });
      let canvas = document
        .getElementById("zp-report-qrcode")
        .getElementsByTagName("canvas");
      this.imgData = canvas[0].toDataURL("image/png");
    },
    IsPc() {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      return flag;
    },
    shareH5() {
      console.log("share");
    },
    test(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
// vant组件样式
::v-deep .van-tabs__wrap {
  height: 70px !important;
  .van-tabs__nav {
    display: inline-block;
    padding: 0;
    .van-tab {
      padding: 0;
      margin-right: 15px;
      display: inline-block;
      .van-tab__text {
        font-size: 0.9em;
      }
    }
    .van-tab--active {
      border-bottom: 0.05em solid black;
      padding-bottom: 0.2em;
    }
  }
  .van-tabs__line {
    display: none;
  }
}
// 海报窗格样式 PC
::v-deep .boswer_poster {
  .poster_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    background-color: #f7f7f7;
    color: #363636;
    span {
      margin-left: 2%;
    }
  }
  .downImg {
    transform: translate(5vh, 5vh);
    height: 500px;
  }
  .poster_container {
    width: 100%;
    height: 500px;
    .back_img {
      transform: translate(7vh, 5vh);
      height: 500px;
      width: 75%;
      background-size: 100% 500px;
      background-repeat: no-repeat;
      .isAI_mark {
        height: 18%;
      }
      .back_title {
        color: #2d5c88;
        display: inline-block;
        width: 100%;
        line-height: 14vh;
        text-align: center;
        font-size: 18px;
      }
      .poster_info {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 1vh;
        .poster_item {
          display: flex;
          flex-direction: column;
          div {
            display: flex;
            align-items: center;
            span,
            p {
              font-size: 0.2em;
            }
            span {
              margin-right: 10px;
            }
            p {
              color: #9a9ba8;
            }
          }
        }
      }
      .poster_img {
        background-size: 25% 25%;
      }
      .poster_desc {
        width: 85%;
        margin: 0 auto;
        span {
          display: inline-block;
          font-size: 0.2rem;
          margin-bottom: 0.1rem;
        }
        p {
          font-size: 0.2em;
          line-height: 3.2em;
          overflow: hidden;
          color: #9a9ba8;
        }
      }
      .qrcode {
        display: flex;
        justify-content: flex-end;
        margin: 0 0 0 70%;
        width: 2em;
        height: 2em;
        background-size: 2em 2em;
        background-repeat: no-repeat;
        img {
          width: 2em;
          height: 2em;
        }
      }
    }
  }
  .save {
    background-color: #2a2a30;
    height: 50px;
    border: 0;
    border-radius: 0;
  }
  .van-icon {
    font-size: 28px;
    top: 4%;
    transform: translateY(-50%);
  }
}
// 遮罩层
.water-mark {
  position: fixed;
  width: 100%;
  max-width: 750px;
  height: 100vh;
  z-index: 5;
  pointer-events: none;
}
// 页面主体样式
.bodydiv {
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 13vh;
  font-size: 20px;
  .top-desc {
    background-color: white;
    border-radius: 20px;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .desc_title {
      min-width: calc(25% + 40px);
      margin-top: 10px;
      box-sizing: border-box;
      border-radius: 45px;
      color: white;
      padding: 10px 20px;
      text-align: center;
      font-size: 1em;
      white-space: nowrap;
    }
    .desc_result {
      width: 100%;
      margin-top: 0.5em;
      position: relative;
      letter-spacing: 0.2em;
      text-align: center;
      font-size: 1.5em;
      color: black;
      &.fake {
        background: url('https://oss.turingsenseai.com/1623908979338852921.png') no-repeat;
        background-size: auto 100%;
        background-position: 49% center;
      }
      &.real {
        background: url('https://oss.turingsenseai.com/1623909016721708515.png') no-repeat;
        background-size: auto 100%;
        background-position: 49% center;
      }
    }
    .desc_container {
      width: 90%;
      margin-top: 40px;
      .desc_label {
        white-space: nowrap;
        font-weight: 700;
        width: 140px;
        margin-right: 10px;
        font-size: 0.9em;
        white-space: nowrap;
      }
      .breif_info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        img {
          border-radius: 15px;
          width: 170px;
          height: 170px;
        }
        .info_item {
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          p {
            width: 80%;
            border-bottom: 1px solid;
            font-size: 0.9em;
          }
          div {
            display: flex;
          }
        }
        .info_img {
          position: relative;
          .img_mark {
            width: 170px;
            height: 170px;
            position: absolute;
            z-index: 6;
            top: 0;
          }
        }
      }
      .desc {
        display: flex;
        .label_container {
          width: 100%;
          text-align: justify;
          p {
            font-size: 0.9em;
          }
        }
      }
    }
    .more {
      margin: 10px 0;
      position: relative;
      z-index: 6;
      p {
        font-size: 0.9em;
        width: 100%;
        text-align: center;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }
  .bottom-detail {
    margin-top: 20px;
    background-color: white;
    border-radius: 20px;
    width: 80%;
    margin-bottom: 20px;
    .detail_title,
    .detail_container {
      margin: 3% 4%;
    }
    .detail_container {
      .point_content {
        width: 100%;
        border-top: 1px solid RGB(240, 240, 245);
        .precent {
          position: relative;
          margin-top: 14%;
          .linear {
            width: 100%;
            height: 10px;
            background-color: #b3d9fc;
            background: linear-gradient(
              90deg,
              #557aff 0%,
              #4642ff 6.41%,
              #ff5572 102.62%
            );
          }
          .position_text {
            width: 150px;
            position: absolute;
            top: -50px;
            font-weight: 700;
            font-size: 1em;
          }
          .position {
            width: 4px;
            height: 18px;
            background-color: black;
            position: absolute;
            transform: translateY(-8px);
          }
          .precent_tip {
            display: flex;
            justify-content: space-between;
            font-size: 0.9em;
            color: RGB(168, 168, 180);
          }
        }
        .ponit_pic {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: row;
          margin: 20px 0;
          .picT,
          .picF {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
              width: 265px;
              height: 265px;
            }
          }
          .picF {
            position: relative;
            .fake_mark {
              position: absolute;
              border: 1px solid red;
              z-index: 7;
              border-radius: 45px;
              width: 9%;
              height: 8%;
            }
          }
          .pic_markT {
            position: absolute;
            top: 0;
            z-index: 6;
            width: 60%;
            height: 90%;
          }
          .pic_markF {
            position: absolute;
            top: 0;
            z-index: 6;
            height: 3.5rem;
            width: 3.5rem;
          }
          img {
            width: 35%;
            height: 35%;
            background-color: black;
            object-fit: contain;
            margin-bottom: 10px;
          }
          .trueArea {
            position: absolute;
            background-color: rgba(0, 0, 0, 0);
          }
          .trueP {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .truePic {
              width: 60%;
              height: 60%;
              background-color: black;
              object-fit: contain;
              margin-bottom: 10px;
            }
          }
          p {
            color: RGB(181, 181, 181);
          }
        }
        .point_dsc {
          margin: 0 auto;
          width: 90%;
          border-radius: 15px;
          background-color: RGB(248, 248, 251);
          border: 1px solid RGB(238, 238, 238);
          p {
            padding: 2%;
          }
        }
      }
    }
  }
  .ccic-top {
    width: 100%;
    height: 20vh;
    background: linear-gradient(270.23deg, #093e73 0.15%, #1a65a9 99.76%);
    background-image: url(https://oss.turingsenseai.com/1680575478886225623.png);
    background-size: 100% 20vh;
    position: relative;
    z-index: 4;
  }
}
// 整体页面 ai/中检
.appraisal-report.zj {
    .bodydiv {
      background: linear-gradient(270.23deg, #093E73 0.15%, #1A65A9 99.76%);
      .top-desc .desc_title {
        background-color: RGB(10,63,116);
      }
    }
  }
.appraisal-report .bottom-btn {
    width:100vw;
    height:100%;
    position: absolute;
    top:0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:9;
    background-color:#4C4C4C;
    opacity: 0.8;
}
// 中检底部
.ccic-bottom {
  width: 100%;
  height: 26vh;
  margin-bottom: 5vh;
  position: relative;
  z-index: 6;
  background-size: 100% 31vh;
  background-image: url(https://oss.turingsenseai.com/1680519891205716487.png);
}
.share {
  background-color: white;
  height: 7vh;
  position: fixed;
  bottom: 0;
  z-index: 6;
  width: 100%;
  max-width: 750px;
  display: flex;
  justify-content: center;
  align-items: center;
}
// 海报 mobile
::v-deep .poster {
  .poster_title {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    background-color: #f7f7f7;
    color: #363636;
    span {
      font-size: 1.1em;
      margin-left: 2%;
    }
  }
  // .poster_container {
  //   width: 73%;
  //   margin: 0 auto;
  //   // margin-top: 2vh;
  //   display: flex;
  //   align-items: center;
  //   .back_img {
  //     width: 100%;
  //     background-repeat: no-repeat;
  //     .back_IMG {
  //       width: 73%;
  //       position: absolute;
  //       z-index: -1;
  //     }
  //     .isAI_mark {
  //       height: 14vh;
  //     }
  //     .back_title {
  //       color: #2d5c88;
  //       display: inline-block;
  //       width: 100%;
  //       line-height: 14vh;
  //       text-align: center;
  //       font-size: 1.4em;
  //     }
  //     .poster_info {
  //       display: flex;
  //       justify-content: space-around;
  //       align-items: center;
  //       .poster_item {
  //         display: flex;
  //         flex-direction: column;
  //         div {
  //           display: flex;
  //           align-items: center;
  //           margin-bottom: 20px;
  //           span {
  //             font-size: 0.9em;
  //             margin-right: 10px;
  //           }
  //           p {
  //             font-size: 0.9em;
  //             color: #9a9ba8;
  //           }
  //         }
  //       }
  //     }
  //     .poster_desc {
  //       width: 85%;
  //       span {
  //         display: inline-block;
  //         font-size: 1em;
  //         margin-bottom: 5px;
  //       }
  //     }
  //     .bottom-icon {
  //       width: 100%;
  //     }
  //     .qrcode {
  //       display: flex;
  //       justify-content: flex-end;
  //       margin: 0 0 0 70%;
  //       width: 4em;
  //       height: 4em;
  //       background-size: 4em 4em;
  //       background-repeat: no-repeat;
  //       img {
  //         width: 4em;
  //         height: 4em;
  //       }
  //     }
  //   }
  // }
  .downImg {
    width: 73%;
    height: 60vh;
  }
  .save {
    border: none;
    background-color: #2a2a30;
    height: 6vh;
  }
  .van-icon {
    top: 3.5%;
    transform: translateY(-50%);
  }
}

.boswer_poster {
  .poster_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    background-color: #f7f7f7;
    color: #363636;
    span {
      margin-left: 2%;
    }
  }
  .downImg {
    transform: translate(5vh, 5vh);
    height: 600px;
  }
  // .poster_container {
  //   width: 100%;
  //   height: 500px;
  //   // display: flex;
  //   // justify-content: center;
  //   // align-items: center;
  //   .back_img {
  //     transform: translate(7vh, 5vh);
  //     height: 500px;
  //     width: 75%;
  //     background-size: 100% 500px;
  //     background-repeat: no-repeat;
  //     .isAI_mark {
  //       height: 18%;
  //     }
  //     .back_title {
  //       color: #2d5c88;
  //       display: inline-block;
  //       width: 100%;
  //       line-height: 14vh;
  //       text-align: center;
  //       font-size: 18px;
  //     }
  //     .poster_info {
  //       display: flex;
  //       justify-content: space-around;
  //       align-items: center;
  //       // margin-bottom: 1vh;
  //       .poster_item {
  //         display: flex;
  //         flex-direction: column;
  //         div {
  //           display: flex;
  //           align-items: center;
  //           // margin-bottom: 5px;
  //           span,
  //           p {
  //             font-size: 0.2em;
  //           }
  //           span {
  //             margin-right: 10px;
  //           }
  //           p {
  //             color: #9a9ba8;
  //           }
  //         }
  //       }
  //     }
  //     .poster_img {
  //       background-size: 25% 25%;
  //     }
  //     .poster_desc {
  //       width: 85%;
  //       margin: 0 auto;
  //       span {
  //         display: inline-block;
  //         font-size: 0.2rem;
  //         margin-bottom: 0.1rem;
  //       }
  //       p {
  //         font-size: 0.2em;
  //         line-height: 3.2em;
  //         overflow: hidden;
  //         // text-overflow: ellipsis;
  //         // display: -webkit-box;
  //         // -webkit-line-clamp: 4;
  //         // -webkit-box-orient: vertical;
  //         color: #9a9ba8;
  //       }
  //     }
  //   }
  // }
  .save {
    background-color: #2a2a30;
    height: 50px;
    border: none;
    border-radius: 0;
  }
  .van-icon {
    font-size: 28px;
    top: 4%;
    transform: translateY(-50%);
  }

}
</style>
